import { APIProgress } from '@tob/shared/api-constants';
import {
  BUSINESS_ACCOUNT_INFO,
  FETCH_ACCOUNT_INFO,
  FETCH_LOGIN_STATUS,
} from './actionTypes';
import { AccountState, AccountAction } from './types';
import getIn from '@shopee/get-in';
import { initialState } from './constants';

export function reducer(
  state: AccountState = initialState,
  action: AccountAction
): AccountState {
  switch (action.type) {
    case FETCH_ACCOUNT_INFO.REQUESTED:
      return {
        ...state,
        accountProgress: APIProgress.Requested,
        accountError: null,
      };
    case FETCH_ACCOUNT_INFO.SUCCESS: {
      return {
        ...state,
        accountProgress: APIProgress.Success,
        account: getIn(action.payload, ['account'], null),
        oneCredentialLinked:
          getIn(action.payload, ['one_credential_linked'], false) || false,
        oneCredentialWhitelisted:
          getIn(action.payload, ['one_credential_whitelisted'], false) || false,
      };
    }
    case FETCH_ACCOUNT_INFO.FAILED:
      return {
        ...state,
        accountProgress: APIProgress.Failed,
        accountError: action.payload.error,
      };
    case FETCH_LOGIN_STATUS.REQUESTED:
      return {
        ...state,
        loginStatusProgress: APIProgress.Requested,
      };
    case FETCH_LOGIN_STATUS.SUCCESS:
      return {
        ...state,
        loginStatusProgress: APIProgress.Success,
        loginStatus: {
          userId: getIn(action.payload, ['userid']),
        },
      };
    case FETCH_LOGIN_STATUS.FAILED:
      return {
        ...state,
        loginStatusProgress: APIProgress.Failed,
        loginStatusError: action.payload.error,
      };
    case BUSINESS_ACCOUNT_INFO.UPDATE:
      return {
        ...state,
        account: {
          ...state.account,
          ...getIn(action.payload, ['account']),
        },
      };
    default:
      return state;
  }
}
